import React from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {iterateResidentEventsByResident} from '../../lib/queries'
import Timeline from '../KnowYourResident/Timeline'
import KYRFilter from '../KnowYourResident/KYRFilter'
import RXRButton from '../RXRButton'
import {KYRScreenLayoutDashboard} from '../../assets/styles/layout'
import {MAP_PRIMARY_RECORD_TO_FILTER_LABEL} from '../KnowYourResident/KYRConstants'

const useStyles = makeStyles(theme => ({
  rightIconButton: {
    textAlign: 'right',
    marginRight: 12,
  },
  timelineContainer: {
    ...KYRScreenLayoutDashboard,
  },
}))

function ProfileTimeline(props) {
  const classes = useStyles()
  const [residentEventsData, setResidentEventsData] = React.useState([])
  const [isEventDataLoading, setIsEventDataLoading] = React.useState(true)
  const iteratorRef = React.useRef(null)

  React.useEffect(() => {
    iteratorRef.current = iterateResidentEventsByResident(props.residentId)
    loadMoreEvents()
  }, [])

  const loadMoreEvents = () => {
    setIsEventDataLoading(true)
    iteratorRef.current
      .next()
      .then(events => {
        setResidentEventsData([...residentEventsData, ...events])
      })
      .finally(() => {
        setIsEventDataLoading(false)
      })
  }

  const filteredAndSortedEvents =
    props.filterState.length > 0
      ? residentEventsData.filter(event => props.filterState.includes(MAP_PRIMARY_RECORD_TO_FILTER_LABEL[event.primaryRecord]))
      : []

  return (
    <div>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <div className={classes.rightIconButton}>
            <KYRFilter onChange={props.setFilterState} selectedFilters={props.filterState} />
          </div>
        </Grid>
      </Grid>
      <div className={classes.timelineContainer}>
        <Timeline
          isEventDataLoading={isEventDataLoading}
          filterStateParent={props.filterState}
          residentEventsData={filteredAndSortedEvents}
          navigationType={'default'}
        />

        {!isEventDataLoading && !iteratorRef.current.hasCompleted ? (
          <RXRButton type={RXRButton.TYPE_TEXT} onClick={loadMoreEvents}>
            Load more
          </RXRButton>
        ) : null}
      </div>
    </div>
  )
}

ProfileTimeline.propTypes = {
  residentId: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired,
  filterState: PropTypes.array.isRequired,
}

export default ProfileTimeline
